import { render, staticRenderFns } from "./two.vue?vue&type=template&id=3993248c&scoped=true&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./two.vue?vue&type=style&index=0&id=3993248c&lang=scss&scoped=true&"
import style1 from "./two.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993248c",
  null
  
)

export default component.exports